<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <paymentBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import paymentBannerComponent from '../payment/paymentBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'bookingComponent',
  components: {
    headerComponent,
    paymentBannerComponent,
    footerComponent,
  },
};
</script>
